<script>
export default {
  name: "DidoExploreFacetFieldFilter",
};
</script>

<script setup>
import { ref, computed } from "vue";

// define Props
const props = defineProps({
  itemsInFacets: { type: Array, required: true },
  itemsSelected: { type: Array, required: true },
  facetField: { type: String, required: true },
  facetLabel: { type: String, required: true },
  moreLimit: { type: Number, required: false, default: 10 },
  order: { type: Array, required: false, default: () => [] },
});
// Define Emits
const emit = defineEmits(["update-facet"]);

// define compûted data for more button limit
const moreButtonLimit = computed(() =>
  props.moreLimit < props.itemsInFacets.length
    ? props.moreLimit
    : props.itemsInFacets.length,
);
const showMoreInFacet = ref(false);

// define computed datas
const itemsInFacetsOrdered = computed(() => {
  if (props.order.length === 0)
    return [...props.itemsInFacets].sort(
      (itemA, itemB) => itemB.count - itemA.count,
    );
  return [...props.itemsInFacets].sort(
    (itemA, itemB) =>
      props.order.findIndex((val) => itemA.value === val) -
      props.order.findIndex((val) => itemB.value === val),
  );
});
const hasMoreThanLimit = computed(
  () => props.moreLimit < props.itemsInFacets.length,
);

// define methods
const clickOnItem = (itemValue) => {
  const action = props.itemsSelected.find((selected) => selected === itemValue)
    ? "remove"
    : "add";
  emit("update-facet", { field: props.facetField, action, value: itemValue });
};
const iconCheckbox = (itemValue) =>
  props.itemsSelected.find((selected) => selected === itemValue)
    ? "mdi-checkbox-marked-outline"
    : "mdi-checkbox-blank-outline";
</script>

<template>
  <QList
    v-if="props.itemsInFacets && props.itemsInFacets.length"
    dense
    class="dido-facet-list-items q-ma-sm"
  >
    <QItemLabel dense header class="q-px-none q-py-xs text-bold">
      {{ props.facetLabel }}
    </QItemLabel>
    <QItem
      v-for="item in itemsInFacetsOrdered.slice(0, moreButtonLimit)"
      :key="item.value"
      v-ripple
      clickable
      dense
      :active="
        !!props.itemsSelected.find((selected) => selected === item.value)
      "
      active-class="text-secondary text-bold"
      class="text-caption"
      @click="clickOnItem(item.value)"
    >
      <QItemSection avatar>
        <QIcon :name="iconCheckbox(item.value)" />
      </QItemSection>
      <QItemSection>{{ item.display }}</QItemSection>
      <QItemSection avatar>{{ item.count }}</QItemSection>
    </QItem>
    <template v-if="hasMoreThanLimit && showMoreInFacet">
      <QItem
        v-for="item in itemsInFacetsOrdered.slice(moreButtonLimit)"
        :key="item.value"
        v-ripple
        clickable
        dense
        :active="!!itemsSelected.find((selected) => selected === item.value)"
        active-class="text-secondary text-bold"
        class="text-caption"
        @click="clickOnItem(item.value)"
      >
        <QItemSection avatar>
          <QIcon :name="iconCheckbox(item.value)" />
        </QItemSection>
        <QItemSection>{{ item.display }}</QItemSection>
        <QItemSection avatar>{{ item.count }}</QItemSection>
      </QItem>
    </template>
    <QItem v-if="hasMoreThanLimit">
      <QItemSection />
      <QItemSection side>
        <QChip
          :icon="`mdi-${showMoreInFacet ? 'minus' : 'plus'}-circle`"
          size="sm"
          :label="`voir ${showMoreInFacet ? 'moins' : 'plus'}`"
          square
          color="secondary"
          text-color="white"
          clickable
          :title="
            showMoreInFacet ? 'Voir moins d\'éléments' : 'Voir plus d\'éléments'
          "
          @click="showMoreInFacet = !showMoreInFacet"
        />
      </QItemSection>
    </QItem>
  </QList>
</template>

<style lang="sass" scoped>
.dido-facet-list-items
  :deep( .q-item)
    padding-left: 0!important
    padding-right: 0!important
  :deep( .q-item__section--main)
    word-break: break-word
  :deep( .q-item__section--avatar)
    max-width: 30px
    min-width: 30px
</style>
